import { Component, input, output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faBarsFilter, faClose } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'eiq-grid-filter-bar',
  templateUrl: 'grid-filter-bar.component.html',
  styleUrls: ['./grid-filter-bar.component.scss']
})
export class GridFilterBarComponent {
  searchCtrl = input<FormControl>();
  searchPlaceholder = input<string>();
  testId$ = input<string>();
  useAdvancedFilter = input<boolean>(true);
  numberOfFilterApplied = input<number>(0);

  clearAdvancedFilter = output();
  openAdvancedFilter = output();

  faBarsFilter = faBarsFilter;
  faClose = faClose;
}
